import { API_URL } from "../config/axiosApi/axiosApi";

export {
  insertTokenAtCursor,
  resolveMessageWithSamples,
  truncateMessage,
} from "./smsTemplateUtils";

/** Build absolute URL for company media library file paths. */
export const resolveMediaUrl = (filePath) => {
  if (!filePath) return "";
  const base = (API_URL || "").replace(/\/$/, "");
  const path = String(filePath).replace(/^\//, "");
  return `${base}/${path}`;
};

/** Layout fields are injected automatically by the email shell (not inserted by the user). */
export const EMAIL_PRESET_LAYOUT_PLACEHOLDER_KEYS = new Set([
  "heroimageurl",
  "restaurantname",
  "companyname",
  "reservationurl",
]);

/** SMS presets exclude email/layout-only placeholders. */
export const SMS_PRESET_EXCLUDED_PLACEHOLDER_KEYS = new Set([
  "restaurantname",
  "heroimageurl",
]);

export const filterSmsContentPlaceholders = (placeholders = []) =>
  (Array.isArray(placeholders) ? placeholders : []).filter((p) => {
    const key = String(p.key ?? p.Key ?? p.token ?? p.Token ?? "").toLowerCase();
    return key && !SMS_PRESET_EXCLUDED_PLACEHOLDER_KEYS.has(key);
  });

/** Email-only placeholders merged when API catalog is missing newer tokens. */
export const EMAIL_PRESET_EXTRA_PLACEHOLDERS = [
  {
    key: "MenuUrl",
    label: "Menu URL",
    token: "{{MenuUrl}}",
    sampleValue: "https://example.com/restaurant",
  },
];

/** Keep only placeholders meant for subject/body content editing. */
export const filterEmailContentPlaceholders = (placeholders = []) =>
  (Array.isArray(placeholders) ? placeholders : []).filter((p) => {
    const key = String(p.key ?? p.Key ?? p.token ?? p.Token ?? "").toLowerCase();
    return key && !EMAIL_PRESET_LAYOUT_PLACEHOLDER_KEYS.has(key);
  });

/** Ensure link placeholders always appear in the email preset editor. */
export const mergeEmailPresetPlaceholders = (apiPlaceholders = []) => {
  const normalized = filterEmailContentPlaceholders(
    Array.isArray(apiPlaceholders) ? [...apiPlaceholders] : []
  );
  const existingKeys = new Set(
    normalized.map((p) =>
      String(p.key ?? p.Key ?? p.token ?? p.Token ?? "").toLowerCase()
    )
  );

  EMAIL_PRESET_EXTRA_PLACEHOLDERS.forEach((extra) => {
    if (existingKeys.has(extra.key.toLowerCase())) return;
    normalized.push({
      key: extra.key,
      label: extra.label,
      token: extra.token,
      sampleValue: extra.sampleValue,
      Key: extra.key,
      Label: extra.label,
      Token: extra.token,
      SampleValue: extra.sampleValue,
    });
  });

  return normalized;
};

/** Strip HTML tags for list preview snippets. */
export const truncateHtmlText = (html, maxLen = 80) => {
  if (!html) return "—";
  const text = String(html)
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, " ")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return "—";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen)}…`;
};
